<template>
<base-modal v-bind:modalTitle="'Edit Condition'" v-on:save="save()" v-on:close="close()">
  <FormulateForm>
      <FormulateInput type="select" :options="fieldOptions" v-model="model.field" label="Field" validation="required" />
      <FormulateInput type="radio" :options="opOptions" v-model="model.op" />
      <FormulateInput v-if="valuesOptions && model.op && model.op.arity == 2" type="select" :options="valuesOptions" v-model="model.values" label="Value(s)" validation="required" />
      <FormulateInput v-else-if="valuesOptions && model.op && model.op.arity == 'n'"
                      type="checkbox"
                      :wrapper-class="['multiple-choices']"
                      :options="valuesOptions"
                      v-model.lazy="model.values" label="Value(s)" validation="required" />
      <FormulateInput v-else-if="model.op && model.op.arity == 2" type="text" v-model.lazy="model.values" label="Value" validation="required"/>
      <FormulateInput v-else-if="model.op && model.op.arity == 'n'" type="text" v-model.lazy="model.values" label="Value(s)" help="Use a comma to separate values" validation="required"/>
  </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build. 
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
   components: {
     BaseModal
   },
   props: {
     availableFields: {
       type: Array
     },
     condition: {
       type: Object,
       default () {
         return {
           id: null,
           field: null,
           op: null,
           values: ''
         };
       }
     },
   },

   data () {
     return {
       fields: {},
       model: null,
       dataTypeList: []
     };
   },

   created () {
     this.model = _.clone(this.condition, true);
     

     if (this.model.id == null) {
       this.model.id = this.randomId();
     }

       if (this.model.op &&
           this.model.op.arity == 'n' &&
           _.isArray(this.model.values) &&
           !this.valuesOptions) {
           this.model.values = _.join(this.model.values, ', ');
       }

   },
   computed: {
     opOptions: function () {
       if (this.model && this.model.field) {
         var field = this.model.field;

         return field.operators.map(function (e) {
           return {
             id: e.key,
             value: e,
             label: e.label
           };
         });
       }
       return [];
     },
     fieldOptions: function () {
       return this.availableFields.map(function (e) {
         return {
           id: e.id,
           value: e,
           label: e.name
         };
       });
       
     },
     valuesOptions: function () {
       if (this.model && this.model.field) {
         return this.model.field.allowed_values;
       }
       return null;
     }
   },
   methods: {
     randomId() {
       var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       return "temp_" + r1 + "_" + r2;
     },
     fetchFields() {
       var self = this;
       API.fields.getList({'t': 'L'})
          .then(function (response) {
            self.fields = response.data;
          });
     },
     close() {
       this.$emit('close');
     },
     save() {
       // Many values converted into an array
       if (this.model.op && (this.model.op.arity == 'n') && !_.isArray(this.model.values)) {
         this.model.values = _.map(_.split(this.model.values, ','), _.trim);
       }
       this.$emit('save', this.model);
     }
   }

 }
</script>


<style>
.multiple-choices > div.formulate-input-group {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// RuleModal.vue?3c5ce28c